export const CONFIGS = {
    minAccountNumberLength: 7,
    sortCodeLength: 6
} as const

export const DEBOUNCE_DELAY = 500
